import { cva, type VariantProps } from 'class-variance-authority';
import type { HTMLAttributes } from 'react';
import { cn } from '../../lib/cn.js';

/** Soft tinted fills — a badge should register without shouting. */
export const badgeVariants = cva(
  'inline-flex items-center gap-1.5 rounded-pill px-2.5 py-1 text-[11px] font-semibold leading-none transition-colors [&_svg]:size-3',
  {
    variants: {
      variant: {
        default: 'bg-surface-hover text-text-muted',
        brand: 'bg-accent text-accent-text',
        soft: 'bg-accent-soft text-accent-soft-text',
        outline: 'border border-border-default text-text-muted',
        success: 'bg-success/12 text-success',
        warning: 'bg-warning/12 text-warning',
        danger: 'bg-danger/12 text-danger',
        info: 'bg-info/12 text-info',
      },
    },
    defaultVariants: { variant: 'default' },
  },
);

export interface BadgeProps
  extends HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}
